let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fp9cm")).then(() => parcelRequire('9ehFI'));